export default "__VITE_ASSET__BzfNDJii__"